<template>
  <v-container
    v-if="selectedCycle.challenge && selectedCycle.challenge.finished_at"
    fluid
    style="min-height: 80vh;"
  >
    <p
      v-if="challenge"
      class="ml-2 text-black font-weight-bold mb-2"
    >
      ID: {{ challenge.id }} / {{ authUser.grade_name }} / {{ selectedCycle.cycle_name }} / Resultados
    </p> 
    <!-- card Page -->
    <v-card
      outlined
      rounded="sm"
      class="mb-2"
    >
      <!-- card tudo 2 -->
      <v-card-text>
        <v-card
          elevation="2"
          rounded="sm"
          class="h-100"
        >
          <v-card-title class="bg-gray-dark px-6 d-flex justify-content-start py-0 pt-3">
            <span
              class="pointer-on-hover p-3 text-center font-weight-regular font-13 text-nitro bg-white"
              style="width: 200px; border-radius: 5px 5px 0px 0px;"
            >
              Análise por prova 
            </span>
          </v-card-title>
          <v-card-text>
            <!-- card filtros -->
            <v-card
              style="background-color: #F9F9F9;"
              class="my-6"
              rounded="sm"
            >
              <v-card-text>
                <v-row>
                  <v-col
                    sm="12"
                    :lg="6"
                    md="6"
                    cols="12"
                  >
                    <div class="d-flex justify-content-between align-items-center mb-2 text-black">
                      <span>
                        Minha nota:
                      </span>
                      <span>
                        {{ cycle.challenge ? cycle.challenge.percentage : 0 }}%
                      </span>
                    </div>
                    <v-progress-linear
                      :value="cycle.challenge ? cycle.challenge.percentage : 0"
                      rounded
                      color="#2C0181"
                      background-color="#C7CAE0"
                      height="13"
                    />
                  </v-col>
                  <v-col
                    sm="12"
                    :md="6"
                    cols="12"
                  >
                    <div class="mb-2 text-black">
                      <span
                        class="legend"
                        style="width:16px; height:15px; background-color: #198754; border-radius: 4px; display: inline-block;"
                      /> Acertos / <span
                        class="legend"
                        style="width:16px; height:15px; background-color: #DC3545; border-radius: 4px; display: inline-block;"
                      /> Erros
                    </div>
                    <div class="d-flex justify-content-between align-items-center mb-2 rounded text-white font-9">
                      <div
                        :style="`background-color: #198754; width: ${(hits / count_questions) * 100}%; max-height: 13px; border-radius: 5px ${challenge_errors == 0 ? '5px' : '0px'} ${challenge_errors == 0 ? '5px' : '0px' } 5px;`"
                        class="d-flex justify-content-center align-items-center text-center"
                      >
                        {{ hits }}  
                      </div>
                      <div
                        :style="`background-color: #DC3545; width: ${(challenge_errors / count_questions) * 100}%; max-height: 13px; border-radius: ${hits == 0 ? '5px' : '0px'} 5px 5px ${hits == 0 ? '5px' : '0px'};`"
                        class="d-flex justify-content-center align-items-center text-center"
                      >
                        {{ challenge_errors }}
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="4"
                    class="text-black"
                  >
                    Disciplina 
                    <v-select
                      v-model="subject_id"
                      outlined
                      dense
                      :items="subjects"
                      item-text="name"
                      item-value="id"
                      label=""  
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="4"
                    class="text-black"
                  >
                    Módulo 
                    <v-select
                      v-model="module_id"
                      outlined
                      dense
                      :items="[{
                        id: 0,
                        name: 'Todos',
                        subject_id: 0,
                      }, ...modules]"
                      item-text="name"
                      item-value="id"
                      label=""  
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <!-- fim card filtros -->
          </v-card-text>

          <v-card-text>
            <v-card
              style="background-color: #F9F9F9;"
              rounded="sm"
            >
              <v-card-text>
                <p class="text-black font-weight-bold">
                  Análise por módulo
                </p>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  :headers="[
                    { text: 'Componente curricular', value: 'subject_name' },
                    { text: 'Tópico', value: 'module' },
                    { text: 'Módulo', value: 'name' },
                    { text: 'Progresso no módulo', value: cycle.plan == 'full' ? 'goal_progress' : 'module_progress' },
                    { text: 'Desempenho no desafio', value: 'performance' },
                  ]"
                  :items="modules"
                  class="elevation-0 t_alternate top-outlined"
                  :disable-sort="$vuetify.breakpoint.mobile"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template #foot>
                    <tr
                      style="background-color: #d9d9d9;"
                      class="text-black font-weight-bold"
                    >
                      <td
                        :colspan="$vuetify.breakpoint.mobile ? 1 : 3"
                        style="border: 1px solid #e0e0e0; padding: 12px; font-weight: bold; text-align: center;"
                      >
                        Resultado alcançado
                        <p
                          v-if="$vuetify.breakpoint.mobile"
                          class="mb-0"
                        >
                          Progresso no módulo: {{ cycle.plan == 'full' ? cycle.goal_progress : cycle.module_progress }}% 
                        </p>
                        <p
                          v-if="$vuetify.breakpoint.mobile"
                          class="mb-0"
                        >
                          Desempenho no desafio: {{ cycle.challenge ? cycle.challenge.percentage : 0 }}% 
                        </p>
                      </td>
                      <td
                        v-if="!$vuetify.breakpoint.mobile"
                        style="border: 1px solid #e0e0e0; padding: 12px; text-align: left;"
                      >
                        {{ cycle.plan == 'full' ? cycle.goal_progress : cycle.module_progress }}%
                      </td>
                      <td
                        v-if="!$vuetify.breakpoint.mobile"
                        style="border: 1px solid #e0e0e0; padding: 12px; text-align: left;"
                      >
                        {{ cycle.challenge ? cycle.challenge.percentage : 0 }}%
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-card-text>
            <v-card
              style="background-color: #F9F9F9;"
              rounded="sm"
            >
              <v-card-text>
                <v-row>
                  <v-col>
                    <p class="text-black font-weight-bold">
                      Análise por questão
                    </p>
                  </v-col>
                  <v-col class="d-flex justify-end">
                    <v-btn
                      color="primary"
                      small
                      @click="show_alternatives = !show_alternatives"
                    >
                      <span class="first-letter-capitalize">
                        {{ show_alternatives ? 'Ocultar' : 'Mostrar' }} alternativas
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  :headers="tableHeadersQuestions"
                  :items="questions"
                  class="elevation-0 t_alternate top-outlined"
                  :class="{
                    'additional-header' : show_alternatives
                  }"
                  :disable-sort="$vuetify.breakpoint.mobile"
                  :items-per-page="-1"
                  hide-default-footer
                >
                  <template #item.hit="{ item }">
                    <div
                      style="width:100px"
                      class="d-flex justify-content-center"
                    >
                      <span
                        v-if="item.hit"
                        class="text-center"
                        style="width: 20px; height: 20px; background-color: #07BC0C; border-radius: 50%; display: flex; align-items: center; justify-content: center;"
                      >
                        <v-icon
                          class="font-10"
                          style="color: white; font-size: 20px;"
                        >
                          fa-check
                        </v-icon>
                      </span>
                      <span
                        v-else
                        class="text-center"
                        style="width: 20px; height: 20px; background-color: #F74A4B; border-radius: 50%; display: flex; align-items: center; justify-content: center;"
                      >
                        <v-icon
                          class="font-10"
                          style="color: white; font-size: 20px;"
                        >
                          fa-times
                        </v-icon>
                      </span>
                    </div>
                  </template>
                  <template #item.user_answer="{ item }">
                    {{ item.user_answer || 'Z' }}
                  </template>
                  <template #item.answer="{ item }">
                    {{ item.answer ? item.answer.toUpperCase() : '' }}
                  </template>
                  <template #item.action="{ item }">
                    <v-btn
                      text
                      color="primary"
                      class="capitalize-first-letter"
                      @click="openQuestionModal(item)"
                    >
                      Visualizar questão
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
              <!-- Modal Visualizar Questão -->
              <v-dialog
                v-model="showQuestionModal"
                max-width="900px"
              >
                <v-card
                  v-if="selectedQuestion"
                  rounded="sm"
                >
                  <v-card-title class="d-flex align-items-center justify-content-between">
                    <span>Questão {{ selectedQuestion.order }} - {{ selectedQuestion.subject_name }} - {{ selectedQuestion.module_name }} </span>
                    <i 
                      class="fa fa-times ml-auto pointer-on-hover" 
                      @click="showQuestionModal = false"
                    />
                  </v-card-title>

                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <v-card
                          outlined
                          rounded="sm"
                        >
                          <v-card-title
                            class="text-h6"
                            style="background-color: #f7f7f7"
                          >
                            Enunciado
                          </v-card-title>
                          <v-divider />
                          <v-card-text class="question-content">
                            <span v-html="selectedQuestion.content" />
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="6">
                        <v-card
                          outlined
                          rounded="sm"
                        >
                          <v-card-title
                            class="text-h6"
                            style="background-color: #f7f7f7"
                          >
                            Resolução
                          </v-card-title>
                          <v-divider />
                          <v-card-text class="question-content">
                            <div v-if="selectedQuestion.resolutionText">
                              <div
                                v-if="isHtml(selectedQuestion.resolutionText)"
                                v-html="selectedQuestion.resolutionText"
                              />
                              <span
                                v-else
                                style="white-space: pre-wrap; text-align: left;"
                              >{{ selectedQuestion.resolutionText }}</span>
                            </div>
                            <span
                              v-else-if="selectedQuestion.resolutionImg"
                              v-html="selectedQuestion.resolutionImg"
                            />
                            <span v-else>
                              Resolução não cadastrada
                            </span>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-card>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
  <v-container
    v-else
    fluid
    class="d-flex align-center justify-center"
    style="min-height: 80vh;"
  >
    <p class="text-center font-weight-bold">
      Os resultados do desafio estarão disponíveis aqui assim que o desafio for realizado.
    </p>
  </v-container>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      subject_id: 0,
      module_id: 0,
      showQuestionModal: false,
      selectedQuestion: null,
      show_alternatives: false,
    }
  },
  
  computed:{
    ...mapGetters(['selectedYear','finishedCycles','selectedCycle','authUser','cycles']),
    subjects(){
      if (!this.cycle || !this.cycle.modules) return [{id: 0, name: 'Todas'}]
      const grouped = _.groupBy(this.cycle.modules, 'subject_name')
      const subjectsList = Object.keys(grouped).map(subject_name => ({
        id: grouped[subject_name][0].subject_id,
        name: subject_name
      }))
      console.log(subjectsList)
      return [
        {
          id: 0,
          name: 'Todas',
        },
        ...subjectsList
      ]
    },
    modules(){
      let modules =  this.subject_id ? this.cycle.modules.filter(m => m.subject_id == this.subject_id) : this.cycle.modules
      if(this.module_id){
        modules = modules.filter(m => m.id == this.module_id)
      }
      return modules
    },
    questions(){
      let questions = this.cycle.challenge_question || []
      if(this.subject_id){
        questions = questions.filter(q => q.subject_id == this.subject_id)
      }
      if(this.module_id){
        questions = questions.filter(q => q.module_id == this.module_id)
      }
      return questions
    },
    count_questions(){
      return this.cycle.challenge_question ? this.cycle.challenge_question.length : 0
    },
    hits(){
      return this.cycle.challenge ? this.cycle.challenge.hits : 0
    },
    challenge_errors(){
      return this.count_questions - this.hits
    },
    cycle(){
      return this.selectedCycle
    },
    challenge(){
      return this.cycle.challenge
    },
    tableHeadersQuestions(){
      const baseHeaders = [
        { text: 'Questão', value: 'order', width: '100px' },
        { text: 'Componente curricular', value: 'subject_name' },
        { text: 'Módulo', value: 'module_name' },
        { text: 'Acerto / Erro', value: 'hit', align: 'center', width: '120px' },
        { text: 'Sua resposta', value: 'user_answer', width: '120px', align: 'center' },
        { text: 'Gabarito', value: 'answer', width: '100px', align: 'center' },
        { text: 'A', value: 'percentage_a', align: 'center' },
        { text: 'B', value: 'percentage_b', align: 'center' },
        { text: 'C', value: 'percentage_c', align: 'center' },
        { text: 'D', value: 'percentage_d', align: 'center' },
        { text: 'E', value: 'percentage_e', align: 'center' },
        { text: 'BR/AN', value: 'percentage_n_a', align: 'center' },
        { text: this.$vuetify.breakpoint.mobile ? 'Ações' : '', value: 'action', align: 'right',  },
      ]
      if (!this.show_alternatives) {
        return baseHeaders.filter(h => !h.value.includes('percentage_'))
      }
      return baseHeaders
    }
  },
  watch:{
    subject_id(){
      this.module_id = 0
    } 
  },
  created(){
    this.getCycles({filters:'&with-metrics', set_current_cycle: true})
    .then(() => {
      if(this.$route.query.params.cycle_config_id){
        this.SET_CYCLE(this.cycles.find(c => c.id == this.$route.query.params.cycle_config_id))
      }
    })
  },
  methods:{
    ...mapActions(['getCycles','getChallenge']),
    ...mapMutations(['SET_CYCLE']),
    openQuestionModal(question){
      this.selectedQuestion = question
      this.showQuestionModal = true
    },
    isHtml(text){
      if(!text) return false
      const htmlRegex = /<[^>]*>/
      return htmlRegex.test(text)
    }
  },
  
}
</script>

<style lang="scss" scoped>
.t_alternate.additional-header {
  ::v-deep thead th:nth-child(7),
  ::v-deep thead th:nth-child(8),
  ::v-deep thead th:nth-child(9),
  ::v-deep thead th:nth-child(10),
  ::v-deep thead th:nth-child(11),
  ::v-deep thead th:nth-child(12) {
    background-color: #f0f0f0 !important;
  }
}

</style>